import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": []
}
const contactsWhoBlockedMe = createSlice({
    name:'contactsWhoBlockedMe',
    initialState,
    reducers:{
        addContactsWhoBlockedMe: (_state,payload)=>{
            return {
                ..._state,
                "id" : uuidv4(),
                "data": payload.payload
            }
        }
    }
});

export default contactsWhoBlockedMe.reducer
export const addContactsWhoBlockedMe = contactsWhoBlockedMe.actions.addContactsWhoBlockedMe